// Module
var code = "<h2 id=\"loan-delinquency\">Loan Delinquency</h2> <p>Find ways to keep your loan from entering default and to protect your ability to obtain credit in the future.</p> ";
// Exports
export default code;